<template>
  <div class="min-h-screen font-sans bg-brand-bg text-brand-dark">
    <Header />
    <main
      class="container flex flex-col flex-1 gap-12 px-4 py-8 mx-auto md:py-16 md:gap-24"
    >
      <!-- <section class="order-2 md:order-1">
        <div class="mb-12 text-center md:mb-16">
          <h1 class="mb-4 text-4xl font-bold md:text-5xl">
            {{ $t("main.fastSelfHelpSupport") }}
          </h1>
        </div>
        <div class="grid grid-cols-1 gap-8 md:grid-cols-3">
          <SupportCard
            :icon="'ChatIcon'"
            :title="$t('main.card1.title')"
            :description="$t('main.card1.description')"
            :linkText="$t('main.card1.link')"
          />
          <SupportCard
            :icon="'ProductIcon'"
            :title="$t('main.card2.title')"
            :description="$t('main.card2.description')"
            :linkText="$t('main.card2.link')"
            :isPrimary="true"
          />
          <SupportCard
            :icon="'ServiceIcon'"
            :title="$t('main.card3.title')"
            :description="$t('main.card3.description')"
            :linkText="$t('main.card3.link')"
          />
        </div>
      </section> -->

      <section class="order-1 mx-auto w-full max-w-4xl md:order-2">
        <div class="mb-12 text-center">
          <h2 class="mb-3 text-4xl font-bold">
            {{ $t("main.getSupport.title") }}
          </h2>
          <p class="text-brand-gray">{{ $t("main.getSupport.replyTime") }}</p>
          <!-- <i18n path="main.getSupport.checkFaq" tag="p" class="text-brand-gray">
            <a @click="jumpToFaq('/sales-questions')" slot="faqLink"  class="font-semibold text-brand-red"
              >{{ $t("footer.preSales") }}</a
            >
          </i18n> -->
        </div>
        <SupportForm />
      </section>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
// import SupportCard from "@/components/card";
import SupportForm from "@/components/submitForm";
// import { ChatIcon, ProductIcon, ServiceIcon } from "@/components/icons/";

export default {
  name: "SupportPage",
  components: {
    Header,
    Footer,
    // SupportCard,
    SupportForm,
    // ChatIcon,
    // ProductIcon,
    // ServiceIcon,
  },
  methods: {
    jumpToFaq(path) {
      this.$router.push(path);
    },
  },
};
</script>
